import { useQuery } from '@apollo/client'
import { getNoteList as getNoteListGql }
   from 'src/graphql/queries/getNoteList.gql'

const useNoteList = (variables, options) => {
   const { data, ...otherQueryReturnValues } = useQuery(getNoteListGql, {
      variables,
      fetchPolicy: 'cache-and-network',
      notifyOnNetworkStatusChange: true,
      ...options
   })

   return {
      ...otherQueryReturnValues,
      noteList: data
         ? data.noteList
         : { items: [], listInfo: {} }
   }
}

export default useNoteList
